module.exports = __webpack_public_path__ + "media/images/client_logos/logo_videdressing_200-c9f38d2beb397aab024c45a1c9561c5d.png";